import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { feedbackApi, FEEDBACK_TYPES } from '../api';
import { APP_VERSION } from '../version';
import Icon from './Icon';

// Tlačítko zpětné vazby + modal. variant="header" = outlined ikonové tlačítko v hlavičce.
export default function FeedbackButton({ variant }) {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [type, setType] = useState('bug');
  const [message, setMessage] = useState('');
  const [saving, setSaving] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    if (!message.trim()) { setError('Napište prosím text.'); return; }
    setSaving(true); setError('');
    try {
      await feedbackApi.submit({
        type, message,
        screen: location.pathname,
        screen_title: document.title,
        device: window.innerWidth < 768 ? 'mobile' : 'desktop',
        app_version: APP_VERSION,
      });
      setDone(true);
    } catch (err) { setError(err.response?.data?.error || 'Odeslání selhalo.'); }
    finally { setSaving(false); }
  };

  const close = () => { setOpen(false); setTimeout(() => { setDone(false); setMessage(''); setType('bug'); setError(''); }, 200); };

  return (
    <>
      {variant === 'header' ? (
        <button className="icon-btn" onClick={() => setOpen(true)}>
          <Icon name="chat" size={15} />
          <span className="hide-mobile">Zpětná vazba</span>
        </button>
      ) : (
        <button className="btn btn-outline btn-sm" onClick={() => setOpen(true)}>💬 Zpětná vazba</button>
      )}
      {open && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }} onClick={close}>
          <div className="card" style={{ maxWidth: 460, width: '100%' }} onClick={(e) => e.stopPropagation()}>
            {done ? (
              <div className="text-center">
                <div style={{ fontSize: 48 }}>🙏</div>
                <h3>Děkujeme!</h3>
                <p className="text-muted mt-8">Zpětná vazba byla odeslána.</p>
                <button className="btn btn-primary mt-16" onClick={close}>Zavřít</button>
              </div>
            ) : (
              <form onSubmit={submit}>
                <h3 className="mb-12">💬 Zpětná vazba</h3>
                <div className="form-group">
                  <label>O co jde?</label>
                  <select className="form-input" value={type} onChange={(e) => setType(e.target.value)}>
                    {Object.entries(FEEDBACK_TYPES).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label>Popište to</label>
                  <textarea className="form-input" rows={5} value={message} onChange={(e) => setMessage(e.target.value)} placeholder="Co se stalo, nebo co byste chtěli…" maxLength={2000} />
                </div>
                <p className="text-muted" style={{ fontSize: '0.78rem' }}>Pro snazší řešení automaticky přiložíme obrazovku, na které jste (<code>{location.pathname}</code>), vaši roli, zařízení a verzi aplikace.</p>
                {error && <div className="alert alert-warning mb-16">{error}</div>}
                <div className="flex gap-8 mt-8">
                  <button type="submit" className="btn btn-primary flex-1" disabled={saving}>{saving ? 'Odesílám…' : 'Odeslat'}</button>
                  <button type="button" className="btn btn-outline" onClick={close}>Zrušit</button>
                </div>
              </form>
            )}
          </div>
        </div>
      )}
    </>
  );
}
